import { _, moment, ts } from '_core';

import { DraftParams } from './types';

export const validate = (params: DraftParams, context: ts.types.universe.UniversePreviewContext) => {
  const date = params.start_date || params.end_date;

  if (_.isEmpty(date)) return ['Snapshot date is a required field.'];

  if (context) {
    if (moment(date).isBefore(moment(context.start_date))) return ['Snapshot date must be inside the universe dates.'];
    if (moment(date).isAfter(moment(context.end_date))) return ['Snapshot date must be inside the universe dates.'];
  }

  if (!_.isEmpty(params.component_errors)) return params.component_errors;

  return [];
};
